// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nK2B","comment":"styles_comment__Oo-2c"};